export default {
  行业协会: 'Industry Association',
  会员单位: 'Member Units',
  家: ' ',
  干货分享: 'Knowledge sharing',
  专家访谈: 'Expert Interviews',
  行业头条: 'Industry Headlines',
  '信息更新中，敬请期待': 'Information updated, so stay tuned!',
  '请完善企业信息, 方便采购商与您联系': 'Please complete the information, so that buyers can contact',
  '30天免费特权': '30 days free',
  恭喜获得: 'Congratulations to get',
  鸿运当头: 'Great Luck',
  供应链企业: 'Supply Chain Companies',
  供应链产品: 'Supply Chain Products',
  申请入驻: 'Apply for Admission',
  加入: 'Join',
  请选择产品品类: 'Please select a product category',
  申请入链: 'Apply to the chain',
  企业负责人: 'Business leaders',
  请输入企业负责人: 'Please enter the business leaders',
  产品分类: 'Product Categories',
  '请阅读勾选协议书！': 'Please read the check-off agreement!',
  供应链品牌: 'Supply Chain Brands',
  // 元宇宙会客厅: 'Meta-Universe Parlor',
  供应链需求: 'Supply Chain Demand',
  距结束还剩: 'Remaining until the end',
  '搜索产品/采购/资讯/企业': 'Search for products/procurement/news/enterprise',
  供应链管理: 'Supply Chain Management',
  进入平台: 'Access to the platform',
  产品品类: 'Product categories',
  新增品牌: 'New brand',
  客户获客总数: 'Total number of customers',
  '若同步异常, 请选择否': 'If the synchronization is abnormal, please select No',
  您已加入: 'You have joined',
  到期: 'Expiration',
  去管理: 'Go to Management',
  供应链: 'Supply Chain',
  产品类别: 'Product Category',
  姓名不能超过30个字符: 'Name cannot exceed 30 characters',
  请输入产品类别: 'Please enter the product category',
  '立即升级/续费': 'Upgrade/Renew Now',
}
